import { useState } from "react";
import { EquiposListContainer } from "./EquiposContainer";
import { VendedoresList } from "./VendedoresList";
import { useDispatch, useSelector } from "react-redux";
import { changeActiveForm, resetEquipoCustom, selectCurrentActiveForm, selectCurrentCustomTeam, selectEquiposDisponibles, setEquposDisponibles } from "../../../store/equiposVentaSlice";
import { useCreateCustomTeamMutation } from "../../../api/vendedorApi";
import { ParseEquiposVentasToEquiposDisponibles } from "./EquiposNocturnos";
import { CustomTeamRequest, EquipoVentas } from "../../../types/vendedor";
import { getErrorMessage } from "../../../utils/errorHelpers";
import { BotonSwapForm } from "./BotonSwapForm";
import { FormularioCreacionEquipos } from "./FormularioCreacionEquiposNocturnos";
import { selectCurrentUserRole } from "../../../api/auth/authSlice";


interface Props {
    equipos?: EquipoVentas[];
    equiposDisponibles?: EquipoVentas[];
}

export function EquiposPersonalizados({ equipos, equiposDisponibles }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const dispatch = useDispatch();

    const anyEquiposAlready = useSelector(selectEquiposDisponibles).length > 0;
    const currentCustomTeam = useSelector(selectCurrentCustomTeam);
    const enableSaveButton = currentCustomTeam != undefined && currentCustomTeam.primerIntegrante != undefined && currentCustomTeam.segundoIntegrante != undefined;
    const currentActiveForm = useSelector(selectCurrentActiveForm);
    const userRole = useSelector(selectCurrentUserRole);

    const primerIntegrante = currentCustomTeam?.primerIntegrante;
    const segundoIntegrante = currentCustomTeam?.segundoIntegrante;

    const [createTeam, { isLoading }] = useCreateCustomTeamMutation();

    // set equipos disponibles
    if(equiposDisponibles && !anyEquiposAlready)
        dispatch(setEquposDisponibles(ParseEquiposVentasToEquiposDisponibles(equiposDisponibles)))

    const handleCreateCustomTeam = async () => {
        try {
            setErrorMessage(null);

            if(primerIntegrante == undefined || segundoIntegrante == undefined) return;

            const request: CustomTeamRequest = {
                primerIntegrante: primerIntegrante.id,
                segundoIntegrante: segundoIntegrante.id,
                tipo: "Manual"
            };

            await createTeam(request).unwrap();
            dispatch(changeActiveForm("Ninguno"));
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }
    return (
        <EquiposListContainer
            title="Creacion de equipos">

            {userRole === "Administrador" 
            ?
            <BotonSwapForm
                showForm={currentActiveForm == "Personalizado"}
                texto="Añadir equipo personalizado"
                onClick={() => {
                    setErrorMessage(null);
                    dispatch(resetEquipoCustom());
                    dispatch(changeActiveForm(currentActiveForm == "Personalizado" ? "Ninguno" : "Personalizado"))
                }}/>
            : <div className="h-[22.5px] my-2 "></div>
            }

            {currentActiveForm == "Personalizado"
            ?
            <FormularioCreacionEquipos
                textoNuevoEquipo="Nuevo equipo personalizado"
                handleCreateCustomTeam={handleCreateCustomTeam}
                equiposDisponibles={equiposDisponibles}
                isLoading={isLoading}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                enableSaveButton={enableSaveButton}
                primerIntegrante={primerIntegrante}
                segundoIntegrante={segundoIntegrante}/>
            :
            <VendedoresList
                equipos={equipos} />
            }
        </EquiposListContainer>
    );
}

